import { Inject, PLATFORM_ID, Injector, Optional, Renderer2, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, Subscription, combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FieldSetting } from 'src/app/share/entity/FieldSetting';
import { BreadCrumbService } from 'src/app/share/service/bread-crumb.service';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { GALoggerService } from 'src/app/share/service/galogger.service';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { AbstractCms } from '../../abstract-cms';
import { CmsService } from '../../service/cms.service';
import { CmsSingle } from './cms-single';

export abstract class AbstractCmsSingle extends AbstractCms<CmsSingle> implements OnInit, OnDestroy {
  moduleKey = 'SINGLE';
  menuSetting: {[p: string]: FieldSetting} = {
    subTitle: {title: 'single.subTitle', isDefault: true, openStatus: true },
    description: {title: 'single.description', isDefault: true, openStatus: true },
    dataProvider: {title: 'single.dataProvider', isDefault: true, openStatus: true },
    keywords: {title: 'single.keywords', isDefault: true, openStatus: true },
    categories: {title: 'single.categories', isDefault: true, openStatus: true },
    licenseContent: {title: 'single.licenseContent', isDefault: true, openStatus: true },
    licenseCc: {title: 'single.licenseCc', isDefault: true, openStatus: true },
    // relatedPeople: { title: 'relatedPeople', isDefault: true, openStatus: true },
    // relatedObject: { title: 'relatedObject', isDefault: true, openStatus: true },
    // relatedEvent: { title: 'relatedEvent', isDefault: true, openStatus: true },
    // relatedVideo: { title: 'relatedVideo', isDefault: true, openStatus: true },
    // relatedAnnals: { title: 'relatedAnnals', isDefault: true, openStatus: true },
    // relatedMocCollection: { title: 'relatedMocCollection', isDefault: true, openStatus: true },
    // relatedPlace: { title: 'relatedPlace', isDefault: true, openStatus: true },
    // relatedRoutes: { title: 'relatedRoutes', isDefault: true, openStatus: true },
    // relatedOrganization: { title: 'relatedOrganization', isDefault: true, openStatus: true },
    // relatedInvisible: { title: 'relatedInvisible', isDefault: true, openStatus: true },
    // relatedNormal: { title: 'relatedNormal', isDefault: true, openStatus: true },
    // relatedSingle: { title: 'relatedSingle', isDefault: true, openStatus: true },
    // relatedLink: { title: 'relatedLink', isDefault: true, openStatus: true },
    // relatedRelics: { title: 'relatedRelics', isDefault: true, openStatus: true },
  };
  data = {
    menuSetting: this.menuSetting
  };
  private breadCrumbsSubscription: Subscription;
  /** 當資料已經載入完可以設定網站描述性標籤的時候觸發 */
  protected setWebTitle$ = new Subject<CmsSingle>();

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected translate: TranslateService,
    protected http: CommonHttpClientService,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected injector: Injector,
    protected templateService: TemplateService,
    protected serverConfigService: ServerConfigService,
    @Optional() @Inject(REQUEST) protected request: Request,
    protected cmsService: CmsService,
    protected breadCrumbService: BreadCrumbService,
    protected renderer: Renderer2,
    protected gALoggerService: GALoggerService,
  ) {
    super(route, router, translate, http, generatorEnv, platformId, injector, templateService, serverConfigService, request);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initObsvWebTitle();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();

    if (this.breadCrumbsSubscription) {
      this.breadCrumbsSubscription.unsubscribe();
      delete this.breadCrumbsSubscription;
    }
  }

  fetchDataObs(params: any): Observable<CmsSingle> {
    if (this.isBrowser) {
      this.gALoggerService.log({
        event: 'click_cms',
        cms_path: params.cmsType,
      });
    }
    return this.http.get<CmsSingle>(`${this.generatorEnv.apiHost}/api/${this.templateService.lang}/cm/single/${params.cmsType}`);
  }

  fetchMenuSettingObs(params: any): Observable<any> {
    return this.cmsService.getMenuSetting(params.cmsType);
  }

  setWebTitle(data: CmsSingle) {
    this.setWebTitle$.next(data);
  }

  initObsvWebTitle() {
    this.breadCrumbsSubscription = combineLatest(
      this.setWebTitle$,
      this.breadCrumbService.breadCrumb$.pipe(filter(breadCrumb => {
        if (breadCrumb && breadCrumb.length > 0) {
          const currBC = breadCrumb[breadCrumb.length - 1];
          const ca = currBC.path.split('/');
          const cbPath = ca[ca.length - 1];
          // console.log(`currBC: {name: ${currBC.name}, path: ${currBC.path}`);
          return this.path === cbPath;
        }
      }))
    ).subscribe(([data, breadCrumb]) => {
      const currBC = breadCrumb[breadCrumb.length - 1];
      const newTitle = `${currBC.name}｜${this.templateService.getSiteName()}`;
      this.templateService.setWebTitle({ title: newTitle, desc: currBC.description || (data && data.description) || '', image: currBC.backgroundImage && currBC.backgroundImage.transform && currBC.backgroundImage.transform.comp || '' });
    });
  }
}
